document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.querySelector('.hamburger');
  const nav = document.querySelector('.nav');
  const servicesLink = document.querySelector('.services-link');
  const hasSubmenuItem = document.querySelector('.nav__item.has-submenu');

  // ハンバーガーメニューの開閉
  hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active');
      nav.classList.toggle('active');

      const isOpen = hamburger.classList.contains('active');
      hamburger.setAttribute('aria-expanded', isOpen);
      nav.setAttribute('aria-hidden', !isOpen);

      // ハンバーガーメニューが開いた時は、サービス一覧のリンクのaria-expandedをtrueに設定
      if (isOpen) {
          servicesLink.setAttribute('aria-expanded', 'true');
          hasSubmenuItem.classList.add('active'); // サブメニューを強制的に表示
      } else {
          servicesLink.setAttribute('aria-expanded', 'false');
          hasSubmenuItem.classList.remove('active'); // サブメニューを非表示
      }
  });

  // メニューの外側をクリックした時の処理
  document.addEventListener('click', (e) => {
      if (!e.target.closest('.nav') && !e.target.closest('.hamburger') && nav.classList.contains('active')) {
          hamburger.classList.remove('active');
          nav.classList.remove('active');
          hamburger.setAttribute('aria-expanded', false);
          nav.setAttribute('aria-hidden', true);
          
          // サブメニューも閉じる
          servicesLink.setAttribute('aria-expanded', 'false');
          hasSubmenuItem.classList.remove('active');
      }
  });

  // サービス一覧リンクのクリックイベント（ハンバーガーメニューが開いていない場合のみ）
  // PC表示時のドロップダウン表示を制御
  if (servicesLink) {
      servicesLink.addEventListener('click', (e) => {
          // ハンバーガーメニューが開いていない場合のみ処理を実行
          if (!nav.classList.contains('active')) {
              e.preventDefault(); // リンクへの遷移を一旦キャンセル
              const isExpanded = servicesLink.getAttribute('aria-expanded') === 'true';
              servicesLink.setAttribute('aria-expanded', !isExpanded);
              hasSubmenuItem.classList.toggle('active');
          }
      });
  }

  // サブメニューの外側をクリックした時にサブメニューを閉じる
  document.addEventListener('click', (e) => {
      if (!e.target.closest('.has-submenu') && hasSubmenuItem.classList.contains('active') && !nav.classList.contains('active')) {
          servicesLink.setAttribute('aria-expanded', 'false');
          hasSubmenuItem.classList.remove('active');
      }
  });
});